export default __webpack_public_path__ + "img/DevOps-Implementation-Services-1.f599ea45.jpg";